import ReactGA from "react-ga4";
import { useEffect } from "react";
import { Hero, Products, Promotions } from "sections";
import ImportantNotice from "sections/Home/ImportantNotice";
import News from "sections/Home/News";
import RizeAd from "sections/Home/RizeAd";

function Home({ sectionHeight }) {
  useEffect(() => {
    // send pageview for homepage
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  return (
    <main className="main">
      <Promotions sectionHeight={sectionHeight} />
      <Hero />
      <Products />
      <ImportantNotice />
      <News />
      <RizeAd />
    </main>
  );
}

export default Home;
